import api from "@/store/api";

interface WaitingRoomAssessmentRequest {
  eventId: string;
  patientId: string;
}

interface WaitingRoomAssessmentResponse {
  assessmentId: null | string;
  hasMore: boolean;
}

interface DeleteWaitingRoomAssessmentRequest {
  assessmentId: string;
  eventId: string;
  patientId: string;
}

const waitingRoomApi = api.injectEndpoints({
  endpoints: (build) => ({
    deleteWaitingRoomAssessment: build.mutation<
      void,
      DeleteWaitingRoomAssessmentRequest
    >({
      query: ({ assessmentId, eventId, patientId }) => ({
        headers: { "Content-Type": "application/json" },
        method: "DELETE",
        url: `/assessments/family/${patientId}/assessment-reservation/${assessmentId}/appointment/${eventId}`,
      }),
    }),
    getNextWaitingRoomAssessment: build.query<
      WaitingRoomAssessmentResponse,
      WaitingRoomAssessmentRequest
    >({
      query: ({ eventId, patientId }) => ({
        body: { appointmentExternalId: eventId },
        method: "POST",
        url: `/assessments/family/${patientId}/assessment-reservation`,
      }),
    }),
  }),
});

const {
  useDeleteWaitingRoomAssessmentMutation,
  useLazyGetNextWaitingRoomAssessmentQuery,
} = waitingRoomApi;

export type { WaitingRoomAssessmentResponse };
export {
  useDeleteWaitingRoomAssessmentMutation,
  useLazyGetNextWaitingRoomAssessmentQuery,
};
